import React from "react";
import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  icon: {
    width: 37,
    height: 33
  }
}));

export default function DefaultPolicyIcon() {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={classes.icon}>
      <svg
        id="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0, 0, 400,400"
      >
        <defs>
          <linearGradient id="secondaryGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop
              offset="0%"
              stopColor={theme.palette.secondary.A400}
              stopOpacity={1}
            />
            <stop
              offset="100%"
              stopColor={theme.palette.secondary.main}
              stopOpacity={1}
            />
          </linearGradient>
        </defs>
        <g id="svgg">
          <path
            id="path0"
            d="M40.491 199.387 L 40.491 392.638 81.902 392.718 C 128.860 392.809,256.722 392.801,316.871 392.703 L 357.055 392.638 357.055 230.874 C 357.055 
            141.904,356.691 54.940,356.245 37.622 L 355.435 6.135 197.963 6.135 L 40.491 6.135 40.491 199.387 M251.534 107.139 C 251.534 153.054,245.392 165.277,208.618 
            192.543 L 198.555 200.004 190.995 194.802 C 177.347 185.410,155.647 162.622,150.514 152.289 L 146.012 143.229 146.012 109.651 L 146.012 76.074 198.773 76.074 
            L 251.534 76.074 251.534 107.139 M171.791 119.325 C 171.805 138.999,173.489 142.857,188.520 157.646 L 197.848 166.824 201.191 164.443 C 218.384 152.200,224.540 
            140.399,224.540 119.681 L 224.540 103.067 198.160 103.067 L 171.779 103.067 171.791 119.325 M268.712 252.147 L 268.712 269.939 198.160 269.939 L 127.607 269.939 
            127.607 252.965 C 127.607 243.630,127.975 235.624,128.425 235.174 C 128.875 234.724,160.624 234.356,198.978 234.356 L 268.712 234.356 268.712 252.147 M268.712 
            304.908 L 268.712 322.699 198.160 322.699 L 127.607 322.699 127.607 305.726 C 127.607 296.391,127.975 288.384,128.425 287.935 C 128.875 287.485,160.624 
            287.117,198.978 287.117 L 268.712 287.117 268.712 304.908 "
            stroke="none"
            fill="url(#secondaryGrad)"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  );
}
